import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { handlePost } from '../../../utils/AxiosUtil';
import ErrorAwareTextField from '../inputfields/ErrorAwareTextField';

class CloseTransaction extends Component {
    state = {
        errors: new Map(),
        comment: ''
    }
    componentDidMount() {
        console.log(this.props);
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        const path = this.props.path;
        const requestObject = {
            "transactionId": this.props.row.privateId,
            "comment": this.state.comment
        };
        handlePost(path, requestObject, this);
    };

    render() {
        return (
            //todo: list proposed?
            <form onSubmit={this.handleSubmit}>
                {this.props.comp}
                <div className='input-group'>
                    <ErrorAwareTextField
                        name="comment"
                        label="Megjegyzés"
                        value={this.state.comment}
                        onChange={e => this.setState({ comment: e.target.value })}
                    />
                </div>
                <h3>Biztos hogy le szeretnéd zárni?</h3>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" onClick={this.props.close}>
                        Mégse
                    </Button>
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Igen
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(CloseTransaction);
